import i18n from 'i18next';
import ent from 'translations/en';
import frt from 'translations/fr';

const resources = {
  fr: { common: frt },
  en: { common: ent },
};

const options = {
  fallbackLng: 'fr',
  load: 'languageOnly',
  ns: ['common'],
  defaultNS: 'common',
  debug: process.env.NODE_ENV !== 'production',
  resources: resources,
  interpolation: {
    escapeValue: false,
  },
};

export const initI18n = (opts, middlewares = [], cb) => {
  if (!i18n.isInitialized) {
    middlewares.map((middleware) => i18n.use(middleware));
  }

  return i18n.init({ ...options, ...opts }, cb);
};

export default i18n;
